import { Nullable, SelectOption } from "@gemlightbox/core-kit";

export const valuesToOptions = (values: Nullable<string[]>): SelectOption[] =>
  values?.map((value) => ({ label: value, value })) || [];
